import { AIAgentAnalyticsItemModel } from "@jugl-web/rest-api/integrations/models/AIAgentAnalyticsItem/AIAgentAnalyticsItemModel";
import { useMemo } from "react";
import { ChatsByCountriesDataEntry } from "../components/ChatsByCountriesWidget";

interface UseChatsByCountriesWidgetDataOptions {
  analyticsData: AIAgentAnalyticsItemModel[];
}

export const useChatsByCountriesWidgetData = ({
  analyticsData,
}: UseChatsByCountriesWidgetDataOptions) => {
  const chatsByCountriesData = useMemo<ChatsByCountriesDataEntry[]>(() => {
    const dict = analyticsData.reduce<Record<string, number>>((acc, item) => {
      if (!item.country) {
        return acc;
      }

      acc[item.country] = (acc[item.country] ?? 0) + 1;

      return acc;
    }, {});

    const data: ChatsByCountriesDataEntry[] = Object.entries(dict).map(
      ([country, value]) => ({ "hc-key": country, value })
    );

    return data;
  }, [analyticsData]);

  return chatsByCountriesData;
};
